import difference from 'lodash/difference';

export function extractIdsFromData<TData>(
  data: TData[],
  idKey: keyof TData
): string[] {
  return data.map((item) => String(item[idKey]));
}

export function toggleSelectionUtil(
  currentSelections: string[],
  id: string
): string[] {
  if (currentSelections.includes(id)) {
    return currentSelections.filter((selectedId) => selectedId !== id);
  }
  return [...currentSelections, id];
}

export function toggleAllUtil(
  currentSelections: string[],
  visibleIds: string[]
): string[] {
  const preserved = difference(currentSelections, visibleIds);
  const hasOverlap = preserved.length < currentSelections.length;

  return hasOverlap ? preserved : [...preserved, ...visibleIds];
}

export function isAllSelectedUtil(
  currentSelections: string[],
  visibleIds: string[]
): boolean {
  if (!visibleIds?.length) {
    return false;
  }
  return visibleIds.every((id) => currentSelections.includes(id));
}

export function isPartiallySelectedUtil(
  currentSelections: string[],
  visibleIds: string[]
): boolean {
  if (!visibleIds?.length) {
    return false;
  }
  const selectedCount = visibleIds.filter((id) =>
    currentSelections.includes(id)
  ).length;
  return selectedCount > 0 && selectedCount < visibleIds.length;
}
